import React from "react";
import css from "../../../Assets/Styles/Home/awesomeServices.module.css";
import AwesomeServicesCard from "./AwesomeServicesCard";
import { mainServices } from "../../../Data/services";
import { Link } from "react-router-dom";
import Fade from "react-reveal/Fade";

const AwesomeServices = () => {
  return (
    <Fade bottom>
      {" "}
      <section className={`${css.awesomeServicesContainer} mb-[100px] `}>
        <div className="text-center">
          <button className="custom_button2 mx-auto">
            <span>~ Our Awesome Services ~</span>
          </button>
          <h2 className=" mb-[28px] leading-[38px]  max-sm:leading-[1.1428] text-[#1E1B18] font-fira font-bold text-[25px] max-sm:text-[42px]">
            We Are <span className="text-secondary">Dedicated</span> To <br />{" "}
            Serve You All Time.
          </h2>
        </div>
        <div
          className={`2xl:max-w-[1320px] max-xl:max-w-[1150px] mt-[50px]   mx-auto ${css.awesomeServices}`}
        >
          {mainServices.slice(0, 4).map((service, i) => (
            <AwesomeServicesCard service={service} key={i} awesomeServices={css} />
          ))}
        </div>
        <div className="flex justify-center mt-10">
          <div className="flex mt-[25px] text-center gap-10 max-sm:gap-0 max-sm:flex-row flex-col max-sm:max-w-[450px] justify-between ">
           
          </div>
        </div>
      </section>
    </Fade>
  );
};

export default AwesomeServices;
